import AppModalContainer from '@nxsys/components/AppModalContainer';
import { defaultMedicalInsuranceTypesOptions } from '@nxsys/constants/AppConstants';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { IBIK } from '@nxsys/types/models/BIK';
import React, { useRef, useState } from 'react';
import MedicalInsuranceForm, {
  MedicalInsuranceFormRef,
  MedicalInsuranceFormValues,
} from './MedicalInsuranceForm';

type EditMedicalInsuranceProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (values: MedicalInsuranceFormValues) => Promise<void>;
  data: IBIK;
};

const EditMedicalInsuranceModal: React.FC<EditMedicalInsuranceProps> = ({
  isOpen,
  toggle,
  onSubmit,
  data,
}: EditMedicalInsuranceProps) => {
  const { messages } = useTypedIntl();

  const formRef = useRef<MedicalInsuranceFormRef>(null);

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (values: MedicalInsuranceFormValues) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AppModalContainer
      title={messages['common.editMedicalInsurance']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => formRef.current?.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
    >
      <MedicalInsuranceForm
        formRef={formRef}
        onSubmit={handleSubmit}
        defaultValues={{
          value: data.value?.toString(),
          startDate: data.startDate,
          type:
            defaultMedicalInsuranceTypesOptions.find(
              (option) => option.value === data.type,
            ) || null,
          description: data.description,
          endDate: data.endDate,
          taxPeriod: data.taxPeriod ?? null,
          eeContribution: data.eeContribution?.toString(),
          totalEeContribution: data.totalEeContribution?.toString(),
        }}
      />
    </AppModalContainer>
  );
};

export default EditMedicalInsuranceModal;
